import styled from "@emotion/styled";
import { List } from "@material-ui/core";
import { units } from "../../../types/units";

export const ListStyledAdd = styled(List)`
  padding: 0;

  .MuiListItemIcon-root {
    min-width: 0;
    margin-right: 1rem;
    opacity: 0.25;
  }

  .MuiListItem-root {
    padding-top: 1rem;
    padding-bottom: 1rem;
    margin-left: -0.5rem;
  }
  .MuiListItemSecondaryAction-root {
    right: 0;
  }
`;

export const AddListItemWrapper = styled.div`
  ${units({
    backgroundColor: "lighterGrey",
  })};

  .MuiGrid-container {
    margin-top: 0;
  }
  .MuiListItemText-root {
    margin: 0;
  }
`;

export const AddListItemInner = styled.div`
  display: block;
  margin: 0rem 0 1rem;
`;
